module.exports = __webpack_public_path__ + "static/media/2021_Cadillac_XT6_int_01_6NX26_1SF_H1Y.74b92055.jpg";